import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "antd";
import { useCallback, useState } from "react";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { ProTag } from "../common/proTag.js";
const ListTableTreeSwitch = ()=>{
    const [busy, setBusy] = useState(false);
    const { optionStore } = useStores();
    const { others: { isAvailable, isPro, typenow, canManageOptions } } = optionStore;
    let disabledPro = false;
    const handleToggle = useCallback(async (state)=>{
        setBusy(true);
        await optionStore.updatePostTypeOptions(typenow, {
            active: state
        });
        window.location.reload();
    }, [
        typenow,
        optionStore
    ]);
    if (!canManageOptions) {
        return null;
    }
    // Always advertise "Page" taxonomy in lite version
    if (!isPro && typenow !== "post") {
        disabledPro = true;
    } else if (!isAvailable) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            paddingTop: 3
        },
        children: [
            /*#__PURE__*/ _jsx(Switch, {
                disabled: disabledPro,
                onChange: handleToggle,
                loading: busy
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    float: "right",
                    padding: disabledPro ? "0px 10px" : "2px 10px"
                },
                children: [
                    __("Enable category tree"),
                    " ",
                    disabledPro && /*#__PURE__*/ _jsx(ProTag, {
                        feature: typenow === "page" ? "page-tree" : "cpt-tree"
                    })
                ]
            })
        ]
    });
};
export { ListTableTreeSwitch };
